module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "child",
    class: {
      'child_active': _vm.active
    },
    on: {
      "click": _vm.childSelected
    }
  }, [(_vm.active) ? _c('Warning', {
    attrs: {
      "active": _vm.modal
    },
    on: {
      "click": _vm.modalEvent
    }
  }, [_vm._v("Переключаясь на другого обучаеющегося вы вернетесь к списку достижений.\nДанные, введеные в форму, не сохранятся.")]) : _vm._e(), _c('header', {
    staticClass: "child__header",
    class: {
      'child__header_margin': _vm.active
    }
  }, [_c('Avatar', {
    attrs: {
      "photo": _vm.photo,
      "gender": _vm.gender,
      "isIndicator": _vm.isIndicator,
      "isApproved": _vm.isApproved,
      "tooltipText": _vm.toolTipText
    }
  }), _c('Info', {
    attrs: {
      "name": _vm.name,
      "surname": _vm.surname,
      "age": _vm.age,
      "showButton": _vm.active,
      "isDisabled": _vm.isDisabled,
      "index": _vm.index
    },
    on: {
      "click": function($event) {
        return _vm.childEditDelete('editChild')
      }
    }
  })], 1), _c('Accordion', {
    ref: "accordion",
    attrs: {
      "opened": _vm.active
    }
  }, [_c('div', {
    staticClass: "child__buttons"
  }, [(_vm.pfdodModule) ? _c('Button', {
    attrs: {
      "bordered": true,
      "disabled": _vm.isPfdod
    },
    on: {
      "click": function($event) {
        return _vm.routeControl('certificate')
      }
    }
  }, [_vm._v("Управление сертификатами")]) : _vm._e(), (_vm.isVisibleElemProgress) ? _c('Button', {
    attrs: {
      "bordered": true,
      "disabled": _vm.isProgress
    },
    on: {
      "click": function($event) {
        return _vm.routeControl('progress')
      }
    }
  }, [_vm._v("Достижения")]) : _vm._e(), (_vm.index !== 0) ? _c('Button', {
    attrs: {
      "bordered": true
    },
    on: {
      "click": function($event) {
        return _vm.childEditDelete('deleteChild')
      }
    }
  }, [_vm._v("Удалить сведения")]) : _vm._e(), (_vm.isVisibleElemResultCourses) ? _c('Button', {
    attrs: {
      "bordered": true,
      "disabled": _vm.routeMeta.resultCourses
    },
    on: {
      "click": function($event) {
        return _vm.routeControl('result-courses')
      }
    }
  }, [_vm._v("Результаты обучения")]) : _vm._e(), (_vm.hasApiModuleConsultations && _vm.isVisibleElemConsultations) ? _c('Button', {
    attrs: {
      "bordered": true,
      "disabled": _vm.routeMeta.consultations
    },
    on: {
      "click": function($event) {
        return _vm.routeControl('consultations')
      }
    }
  }, [_vm._v("Консультации")]) : _vm._e(), (_vm.hasApiModulePortfolio) ? _c('Button', {
    attrs: {
      "bordered": true,
      "disabled": _vm.routeMeta.accessPermission
    },
    on: {
      "click": function($event) {
        return _vm.routeControl('access-permission')
      }
    }
  }, [_vm._v("Настройка доступа")]) : _vm._e()], 1), _c('footer', {
    staticClass: "child__footer"
  }, [_vm._v("Предложения слева подобраны исходя из вашей\nистории просмотров и ваших интересов.\nВы можете ознакомиться с\nними, выбрать и записаться.")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d3f31a4","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/blocks/children/sidebar/components/childrenlist/child/Child.vue
// module id = ea13c1a65f789b29e522
// module chunks = 89